import { memo } from 'react'

const Loading = memo(() => (
  <div className="fts-loading">Der Digitale Kontoauszug wird geladen..</div>
))

Loading.displayName = 'Loading'

export { Loading }
